/* eslint-disable indent */
import { Button } from '@alifd/next';
import { message } from 'antd'; // dialog UI
import axios from 'axios';
import React, { useEffect, useState } from 'react';

import Tab from '@/components/UI/mobile/Tab';

import client from '../../../../lib/feathers';
import DepositDetailModal from './components/DepositDetailModal';
import DepositList from './components/DepositList';
import { DepositListContextProvider } from './context';
import styles from './index.module.scss';

const DepositFrontDeskList = () => {
  const deposit = client.service('deposit');
  const [postalArr, setPostalArr] = useState([]);
  const [selectReceiveCategory, setSelectReceiveCategory] = useState('');
  const [isShowDepositDetailModal, setIsShowDepositDetailModal] =
    useState(false);
  const [robotDeliveryDialog, setRobotDeliveryDialog] = useState(false);
  const [viewPostal, setViewPostal] = useState({});
  const [tab, setTab] = useState(0);
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    client
      .reAuthenticate()
      .then((res) => {
        console.log('==relogin ok', res.user.householdNumbers);

        const { user } = res;

        deposit
          .find({
            query: {
              $or: [
                { household: user.householdNumbers[0] },
                { peopleHousehold: user.householdNumbers[0] },
                { peopleName: user.name },
              ],
              $sort: { status: -1, plateNumber: -1 },
            },
          })
          .then((result) => {
            const postalArr = result.data.filter((item) => {
              const {
                type,
                household,
                recipient,
                peopleHousehold,
                peopleName,
                status,
              } = item;

              const recipientFieldsIsMyHouseholdAndName =
                household === user.householdNumbers[0] &&
                recipient === user.name;
              const recipientFieldsIsMyHouseholdAndEmptyName =
                household === user.householdNumbers[0] && recipient === '';
              const peopleFieldsIsMyHouseholdAndName =
                peopleHousehold === user.householdNumbers[0] &&
                peopleName === user.name;
              const peopleFieldsIsMyHouseholdAndEmptyName =
                peopleHousehold === user.householdNumbers[0] &&
                peopleName === '';

              if (tab === 0) {
                return (
                  status === '未領取' &&
                  ((type === '寄件' &&
                    (recipientFieldsIsMyHouseholdAndName ||
                      recipientFieldsIsMyHouseholdAndEmptyName)) ||
                    (type === '收件' &&
                      (peopleFieldsIsMyHouseholdAndName ||
                        peopleFieldsIsMyHouseholdAndEmptyName)))
                );
              }
              if (tab === 1) {
                return (
                  status === '未領取' &&
                  ((type === '收件' &&
                    (recipientFieldsIsMyHouseholdAndName ||
                      recipientFieldsIsMyHouseholdAndEmptyName)) ||
                    (type === '寄件' &&
                      (peopleFieldsIsMyHouseholdAndName ||
                        peopleFieldsIsMyHouseholdAndEmptyName)))
                );
              }
              return (
                status === '已領取' &&
                (recipientFieldsIsMyHouseholdAndName ||
                  recipientFieldsIsMyHouseholdAndEmptyName ||
                  peopleFieldsIsMyHouseholdAndName ||
                  peopleFieldsIsMyHouseholdAndEmptyName)
              );
            });

            setPostalArr(postalArr);
          });
      })
      .catch((err) => {
        console.log('==relogin fail', err);
      });
  }, [deposit, tab, isUpdate]);

  let selectPostalArr = postalArr;
  switch (selectReceiveCategory) {
    case 'default':
      break;
    case 'unReceive':
      selectPostalArr = postalArr.filter((x) => x.status === '未領取');

      break;

    case 'received':
      selectPostalArr = postalArr.filter((x) => x.status === '已領取');

      break;
    default:
  }

  return (
    <DepositListContextProvider
      value={{
        setViewPostal,
        setIsShowDepositDetailModal,
        setRobotDeliveryDialog,
      }}
    >
      <div className={styles.pageContainer}>
        <div className={styles.tabList}>
          <Tab options={['寄件', '收件', '已完成']} onChange={setTab} />
        </div>
        <DepositList depositList={postalArr} tab={tab} />
      </div>
      {isShowDepositDetailModal ? (
        <DepositDetailModal tab={tab} viewPostal={viewPostal} />
      ) : null}
      {/* 機器人派送 */}
      <div
        className={styles.showRobotoOpen}
        style={{ display: robotDeliveryDialog ? 'flex' : 'none' }}
      >
        <img
          className={styles.showRobotoImg}
          src="img/robot_home.svg"
          alt="圖片"
        />
        <div style={{ marginTop: 10 }}>
          <Button
            className={styles.robotBtn}
            style={{ marginRight: 10 }}
            onClick={async () => {
              const res = await axios.post(
                '/ezcon/api/robot/robotPreparation',
                {
                  depositId: viewPostal._id,
                  householdNumber: viewPostal.household,
                },
                {
                  headers: {
                    authorization: localStorage.getItem('feathers-jwt'),
                  },
                }
              );
              if (res.status === 200) {
                setIsUpdate((pre) => !pre);
                message.success('已安排機器人派送');
                axios
                  .post(
                    '/ezcon/api/robot/goGuardHouse',
                    {
                      depositId: viewPostal._id,
                      householdNumber: viewPostal.household,
                    },
                    {
                      headers: {
                        authorization: localStorage.getItem('feathers-jwt'),
                      },
                    }
                  )
                  .then(() => console.log('success'))
                  .catch((error) => console.log(error));

                setRobotDeliveryDialog(false);
              }
            }}
          >
            是
          </Button>
          <Button
            className={styles.robotBtn}
            onClick={() => {
              setRobotDeliveryDialog(false);
            }}
          >
            否
          </Button>
        </div>
      </div>
    </DepositListContextProvider>
  );
};

export default DepositFrontDeskList;
